import React, { useState } from 'react';
import { History, GitCompare } from 'lucide-react';

const fmt = (d) => (d ? new Date(d).toLocaleString() : '-');

const RevisionHistory = ({ revisions = [], userMap = {}, onCompare }) => {
  const [selected, setSelected] = useState([]);

  const ordered = [...revisions].sort((a, b) => b.version - a.version);

  const toggle = (rev) => {
    setSelected((prev) => {
      const exists = prev.find((r) => r.version === rev.version);
      if (exists) return prev.filter((r) => r.version !== rev.version);
      const next = [...prev, rev];
      return next.slice(-2); // keep max 2
    });
  };

  const isSel = (rev) => selected.some((r) => r.version === rev.version);
  const author = (id) => userMap[id]?.name || userMap[id]?.email || id || '—';

  return (
    <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl" data-testid="cms-revision-history">
      <div className="flex items-center justify-between px-5 py-3 border-b border-slate-700">
        <div className="flex items-center gap-2 text-white font-semibold">
          <History className="w-5 h-5 text-amber-400" /> Revision History
        </div>
        <button
          disabled={selected.length !== 2}
          onClick={() => onCompare(selected[0], selected[1])}
          data-testid="cms-compare-btn"
          className="flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-lg bg-amber-500/20 text-amber-400 hover:bg-amber-500/30 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        >
          <GitCompare className="w-4 h-4" /> Compare
        </button>
      </div>

      {ordered.length === 0 ? (
        <div className="px-5 py-8 text-center text-slate-500 text-sm" data-testid="cms-revisions-empty">
          No revisions yet. Publish this page to create the first revision.
        </div>
      ) : (
        <ul className="divide-y divide-slate-700/50">
          {ordered.map((rev) => (
            <li key={rev.version} className="flex items-start gap-3 px-5 py-3" data-testid={`cms-revision-${rev.version}`}>
              <input
                type="checkbox"
                checked={isSel(rev)}
                onChange={() => toggle(rev)}
                data-testid={`cms-revision-check-${rev.version}`}
                className="mt-1 accent-amber-500"
              />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="px-2 py-0.5 text-xs font-semibold rounded bg-slate-700 text-slate-200">v{rev.version}</span>
                  <span className="text-sm text-slate-300">{fmt(rev.published_at)}</span>
                </div>
                <p className="text-xs text-slate-500 mt-1">by {author(rev.published_by)}</p>
                {rev.revision_notes && (
                  <p className="text-sm text-slate-300 mt-1 italic">“{rev.revision_notes}”</p>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default RevisionHistory;
